/**
 * 区分 periodType（goals.period_type）
 * 出典：仕様書 7 章
 */
export const PERIOD_TYPE_VALUES = ['monthly', 'quarterly', 'yearly', 'custom'] as const;

export type PeriodType = (typeof PERIOD_TYPE_VALUES)[number];

export const PERIOD_TYPE_LABELS: Readonly<Record<PeriodType, string>> = {
  monthly: '月次',
  quarterly: '四半期',
  yearly: '年次',
  custom: 'カスタム', // 274：旧PCRM の表示名（値は変えない）
};
